import { useState, type ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/features/auth/AuthProvider';

/**
 * Tous les fournisseurs de contexte de l'application, dans l'ordre.
 *
 * TanStack Query est la couche de cache serveur : aucune donnee distante ne doit
 * etre stockee dans un `useState`. Cela evite les listes de vehicules obsoletes
 * et les rechargements inutiles sur connexion mobile.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60_000,
            gcTime: 5 * 60_000,
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>{children}</AuthProvider>
    </QueryClientProvider>
  );
}
